var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CONFIG } from "@/config";
import { DEFAULT_LOCALE } from "@/locales";
import React, { useEffect, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Popin } from "./atoms/Popin";
import styles from "./DownloadPopin.module.scss";
import { FileDownloadLink } from "./FileDownloadLink";
import { metrics } from "../analytics/events";
import { uniq } from "lodash";
var requireArtbook = CONFIG.downloads.artbook.folder;
var DOWNLOADS = requireArtbook.keys().map(function (f) { return (__assign({ file: requireArtbook(f) }, CONFIG.downloads.artbook.namePattern(f))); });
var VERSIONS = ["4k", "hd", "ld", null];
var LOCALES = uniq(DOWNLOADS.map(function (e) { return e.locale; }));
export function DownloadPopin(_a) {
    var onClose = _a.onClose, isOpen = _a.isOpen;
    useEffect(function () {
        if (isOpen) {
            metrics.onDownloadPopinDisplayed();
        }
    }, [isOpen]);
    return (React.createElement(Popin, { onClose: function () {
            onClose();
            metrics.clickOnCloseDownloadPopin();
        }, isOpen: isOpen, title: React.createElement(FormattedMessage, { defaultMessage: "Downloads", id: "OnbqrE" }), style: "white" },
        React.createElement(DownloadContent, null)));
}
export function DownloadContent() {
    var intl = useIntl();
    var selectedLanguage = useMemo(function () {
        var lang = intl.locale.split("-")[0];
        return LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;
    }, [intl]);
    return (React.createElement("div", { className: styles.downloadContent },
        CONFIG.downloads.soundtrack && (React.createElement("div", null,
            React.createElement("div", { className: styles.label },
                React.createElement(FormattedMessage, { defaultMessage: "Download Soundtrack", id: "3/+ZBf" })),
            React.createElement(FileDownloadLink, { url: CONFIG.downloads.soundtrack, content: "soundtrack", onClick: function () { return metrics.clickOnDownloadSoundtrack(); } }))),
        React.createElement("div", null,
            React.createElement("div", { className: styles.label },
                React.createElement(FormattedMessage, { defaultMessage: "Download Artbook", id: "j2k9Hx" })),
            React.createElement("div", { className: styles.fileList }, VERSIONS.map(function (quality, index) {
                var artbook = DOWNLOADS.find(function (e) { return e.locale === selectedLanguage && e.quality === quality; });
                if (artbook == null)
                    return null;
                return (React.createElement(FileDownloadLink, { key: index, url: artbook.file, content: "artbook", quality: quality, recommended: quality === CONFIG.downloads.artbook.recommendedQuality, onClick: function () {
                        metrics.clickOnDownloadArtbook(quality, selectedLanguage);
                    } }));
            })))));
}
